/* External dependencies */
import { Action } from 'redux';

/* Local dependencies */
import { User, UpdateUserInput } from '../../../users/types';

export enum UpdateUserActionTypes {
  UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST',
  UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS',
  UPDATE_USER_ERROR = 'UPDATE_USER_ERROR',
}

export interface UpdateUserRequest extends Action<UpdateUserActionTypes.UPDATE_USER_REQUEST> {
  type: UpdateUserActionTypes.UPDATE_USER_REQUEST;
  payload: UpdateUserInput;
  [key: string]: any;
}

export interface UpdateUserSuccess extends Action<UpdateUserActionTypes.UPDATE_USER_SUCCESS> {
  type: UpdateUserActionTypes.UPDATE_USER_SUCCESS;
  payload: User;
  [key: string]: any;
}

export interface UpdateUserError extends Action<'UPDATE_USER_ERROR'> {
  type: 'UPDATE_USER_ERROR';
  error: Error;
}

export type UpdateUserActions = UpdateUserRequest | UpdateUserSuccess | UpdateUserError;

export function updateUserRequestAction(input: UpdateUserInput): UpdateUserRequest {
  return {
    type: UpdateUserActionTypes.UPDATE_USER_REQUEST,
    payload: input,
  };
}

export function updateUserSuccessAction(user: User): UpdateUserSuccess {
  return {
    type: UpdateUserActionTypes.UPDATE_USER_SUCCESS,
    payload: user,
  };
}

export function updateUserErrorAction(error: Error): UpdateUserError {
  return {
    type: UpdateUserActionTypes.UPDATE_USER_ERROR,
    error,
  };
}
